import {
  CorporatePage,
  DefaultMeta,
  sectionCardsWithBool,
} from '../../../../../types/partner-page-types';

export const toShowGenericSection = (
  postData: CorporatePage | undefined,
  metaData: DefaultMeta | undefined,
  section: sectionCardsWithBool
): boolean => {
  if (!postData) return false;
  if (!metaData) return false;
  if (!section.active) return false;
  if (!section.plans.length) return false;
  return true;
};
